/**
 * The zoom control's icon, which says which of the three steps you are on.
 *
 * The plus is always there. The smallest view is a plus unlit, the middle is
 * the same plus lit, and the largest adds a second plus. The owner asked for exactly this: "a magnifying
 * glass with a + in it, but not highlighted, then you tap it and it's
 * highlighted and it again and it does the highlighted with the extra plus."
 *
 * It matters more than an icon usually would, because these screens also carry
 * a search field with a magnifier in it. A control whose glyph never changes
 * reads as a second search button sitting next to the search box - which is
 * what the owner hit: "I didn't even realize that's not even what I was looking
 * for". A glyph that visibly gains a plus as you tap is the thing that tells
 * you it is about size, not about finding.
 *
 * This lived inside Collection.js and only the Cards and Binder screens got it;
 * every wish surface drew lucide's plain ZoomIn, which always shows one plus and
 * never changes. One icon now, everywhere.
 */
export default function ZoomStepIcon({ level = 0, size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="10" cy="10" r="7" />
      <path d="m20 20-4.35-4.35" />
      {/* The plus is always in the glass. The three steps read as: plus and
          plain, plus and lit, two pluses - so the first tap is a change of
          COLOUR rather than a change of glyph, and nothing on the row ever
          looks like a bare search icon. The owner: "default is + in there, next
          is same but blue, last is ++". */}
      <path d="M10 7v6" />
      <path d="M7 10h6" />
      {level >= 2 && <path d="M19.5 4.5v4" strokeWidth="2.2" />}
      {level >= 2 && <path d="M17.5 6.5h4" strokeWidth="2.2" />}
    </svg>
  );
}

/** What the control is for, said out loud for anyone not looking at the glyph. */
export function zoomLabel(level = 0) {
  if (level >= 2) return 'Card size: large';
  if (level >= 1) return 'Card size: medium';
  return 'Card size: small';
}
